/// <reference path='../_all.ts' />


module userAdmin {


  export class UserAdminService implements IUserAdminService {
    static $inject = [
      '$http',
    ];

    constructor(
      // Add the parameter and type definition.
      public $http: ng.IHttpService,
    ) { } 



    //User

    public getData() : ng.IHttpPromise<UserAdminServiceData> {

      return this.$http<UserAdminServiceData>({
          method: "GET"
        , url: "/api/" + pglob.RouteData.CurrentLanguage.hl + "/UserAdmin/"
        , headers: { 'Content-Type': 'application/json' }
      }); 

    }


    public createUser(newUser : NewUserData) : ng.IHttpPromise<User> {

      return this.$http<User>({
          method: "POST"
        , url: "/api/" + pglob.RouteData.CurrentLanguage.hl + "/UserAdmin/CreateUser"
        , headers: { 'Content-Type': 'application/json' }
        , data:  newUser 
      }); 

    }

    
    public updateUser(userId : string, userData : UpdateUserData) : ng.IHttpPromise<User> {

      return this.$http<User>({
          method: "PUT"
        , url: "/api/" + pglob.RouteData.CurrentLanguage.hl + "/UserAdmin/UpdateUser"
        , headers: { 'Content-Type': 'application/json' }
        , params: {
          "userId" : userId,
        }
        , data:  userData 
      }); 

    }


    public deleteUser(guid : string) : ng.IHttpPromise<User> {

      return this.$http<User>({
          method: "DELETE"
        , url: "/api/" + pglob.RouteData.CurrentLanguage.hl + "/UserAdmin/DeleteUser"
        , headers: { 'Content-Type': 'application/json' }
        , params: {
          "userId" : guid,
        }
      }); 

    }


    // Group

    
    public createGroup(groupname : string) : ng.IHttpPromise<{ [name: string] : Group }> {

      return this.$http<{ [name: string] : Group }>({
          method: "POST"
        , url: "/api/" + pglob.RouteData.CurrentLanguage.hl + "/UserAdmin/CreateGroup"
        , headers: { 'Content-Type': 'application/json' }
        , params: {
          "groupname" : groupname,
        }
      }); 

    }

    
    public UpdateGroup(groupname : string, permissions : string[]) : ng.IHttpPromise<{ [name: string] : Group }> {

      return this.$http<{ [name: string] : Group }>({
          method: "PUT"
        , url: "/api/" + pglob.RouteData.CurrentLanguage.hl + "/UserAdmin/UpdateGroup"
        , headers: { 'Content-Type': 'application/json' }
        , params: {
          "groupname" : groupname,
        }
        , data:  permissions 
      }); 

    }


    public deleteGroup(groupname : string) : ng.IHttpPromise<void> {

      return this.$http<void>({
          method: "DELETE"
        , url: "/api/" + pglob.RouteData.CurrentLanguage.hl + "/UserAdmin/DeleteGroup"
        , headers: { 'Content-Type': 'application/json' }
        , params: {
          "groupname" : groupname,
        }
      }); 

    }

    // Permission

    
    public createPermission(permissionName : string, desc : string) : ng.IHttpPromise<{ [name: string] : Permission }> {

      return this.$http<{ [name: string] : Permission }>({
          method: "POST"
        , url: "/api/" + pglob.RouteData.CurrentLanguage.hl + "/UserAdmin/CreatePermission"
        , headers: { 'Content-Type': 'application/json' }
        , params: {
          "permissionName" : permissionName,
        }
        , data: JSON.stringify(desc)
      }); 

    }

    
    public updatePermission(permissionName : string, groups : string[]) : ng.IHttpPromise<{ [name: string] : Group }> {

      return this.$http<{ [name: string] : Group }>({
          method: "PUT"
        , url: "/api/" + pglob.RouteData.CurrentLanguage.hl + "/UserAdmin/UpdatePermission"
        , headers: { 'Content-Type': 'application/json' }
        , params: {
          "permissionName" : permissionName,
        }
        , data:  groups 
      }); 

    }


    public deletePermission(permissionName : string) : ng.IHttpPromise<void> {

      return this.$http<void>({
          method: "DELETE"
        , url: "/api/" + pglob.RouteData.CurrentLanguage.hl + "/UserAdmin/DeletePermission"
        , headers: { 'Content-Type': 'application/json' }
        , params: {
          "permissionName" : permissionName,
        }
      }); 

    }

    
  }

}
